import { computed } from '@ember/object';
import { isBlank } from '@ember/utils';
import { attr } from '@ember-data/model';
import BaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import { Country } from '@square/dashboard-data/models/squareup/common/countries';
export default BaseFragment.extend({
  addressLine1: attr('string'),
  // street 1
  addressLine2: attr('string'),
  // street 2
  addressLine3: attr('string'),
  addressLine4: attr('string'),
  addressLine5: attr('string'),
  locality: attr('string'),
  // city
  sublocality: attr('string'),
  sublocality1: attr('string'),
  sublocality2: attr('string'),
  sublocality3: attr('string'),
  sublocality4: attr('string'),
  sublocality5: attr('string'),
  administrativeDistrictLevel1: attr('string'),
  // state
  administrativeDistrictLevel2: attr('string'),
  administrativeDistrictLevel3: attr('string'),
  postalCode: attr('string'),
  // zip
  countryCode: attr('enum', {
    enumClass: Country
  }),
  addressCoordinates: attr('object'),
  // TODO: squareup.common.location.Coordinates

  // TODO: convert this property into a helper function in utils/global_address.
  formatted: computed('addressLine1', 'addressLine2', 'addressLine3', 'addressLine4', 'addressLine5', 'locality', 'sublocality', 'sublocality1', 'sublocality2', 'sublocality3', 'sublocality4', 'sublocality5', 'administrativeDistrictLevel1', 'administrativeDistrictLevel2', 'administrativeDistrictLevel3', 'postalCode', function () {
    return [this.addressLine1, this.addressLine2, this.addressLine3, this.addressLine4, this.addressLine5, this.locality, this.sublocality, this.sublocality1, this.sublocality2, this.sublocality3, this.sublocality4, this.sublocality5, this.administrativeDistrictLevel1, this.administrativeDistrictLevel2, this.administrativeDistrictLevel3, this.postalCode].reject(item => isBlank(item)).join(', ');
  })
}).reopenClass({
  _modelNameForMigration: 'squareup/common/location/global-address-ed'
});